
import router from '@/router'
import config from '../common.js'
import axiosSetting from 'vue-common-laboratory/dist/utils/requst.js' // 引入axios统一配置方法文件

let methods = axiosSetting(config, router)

// 导出请求方法
export default { ...methods }


// WEBPACK FOOTER //
// ./src/utils/requst.js